import {
  type SourcePageInfo,
  type MediaDataItem,
} from '~/api/interface/landing'
import { AttrKey, OSS_PATH, EN_OSS_PATH } from '~/constants/landing'
export const videoExt = [
  '.mp4',
  '.mov',
  '.avi',
  '.mpeg',
  '.wmv',
  '.rmvb',
  '.webm',
]

export function getSingleMediaData(info: SourcePageInfo) {
  return info?.resource[0]?.mediaArray[0]?.mediaItem?.data
}

export function getCoverData(info: SourcePageInfo) {
  return info?.resource[0]?.mediaArray[0]?.cover?.data
}

export function getMediaArrayData(info: SourcePageInfo) {
  return info?.resource[0]?.mediaArray
}

export function getCurMediaItemAttribute(
  item: MediaDataItem | MediaDataItem[] | undefined,
  attr: AttrKey,
  index?: number
) {
  if (!item) {
    return ''
  }
  if (Array.isArray(item)) {
    return (item[index || 0]?.attributes[attr] as string) || ''
  }
  return (item.attributes[attr] as string) || ''
}

export function getCurCompressedMediaUrl(
  item: MediaDataItem | MediaDataItem[] | undefined
) {
  if (!item) {
    return ''
  }
  if (Array.isArray(item)) {
    return (item[0].attributes.formats.thumbnail.url as string) || ''
  }
  return (item.attributes.formats.thumbnail.url as string) || ''
}

export function getPageInfoAttribute(
  info: SourcePageInfo,
  attr: AttrKey
): string {
  const data = getSingleMediaData(info)
  if (!data) {
    return ''
  }
  if (Array.isArray(data)) {
    return (data[0].attributes[attr] as string) || ''
  }
  return (data.attributes[attr] as string) || ''
}

export function getCoverAttribute(info: SourcePageInfo, attr: AttrKey) {
  const data = getCoverData(info)
  if (!data) {
    return ''
  }
  return getCurMediaItemAttribute(data, attr)
}

export const OSSProcess = (url: string, size: string, format?: string) =>
  `${url}?x-oss-process=image/resize,${size}/format,${format || 'webp'}`

export const getImageUrl = (name: string, size: string) => {
  const url = `${isGlobalVersion() ? EN_OSS_PATH : OSS_PATH}/images/${name}`
  return OSSProcess(url, size)
}

export const isNotSafari = () => {
  if (
    typeof window !== 'undefined' &&
    typeof window.navigator !== 'undefined'
  ) {
    return !(
      /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
    )
  }
  return false // 如果不在浏览器环境中，返回false
}

export const getRedirectLink = (link?: string, query?: boolean) => {
  const current = useRequestURL()

  if (!link) {
    return current.origin
  }

  if (!link.startsWith('http')) {
    link = current.origin + link
  }

  const url = new URL(link)

  if (!query) {
    return url.href
  }

  current.searchParams.forEach((value, key) => {
    url.searchParams.append(key, value)
  })

  return url.href
}
